(function (appComponents) {

	appComponents.services.layout = function (Components) {

		var layout = {};

		layout.name = "layout";


		Components.getComponentPrototype().extend(layout);

		layout._cartCheckout = layout._getService("cartCheckout");
		// load common service components
		// can be delayed and called by request
		layout.commonServices = ["header", "footer", "b2bUnit", "advancedSearch", "whereToBuy",
			"helpers", "ordersBase", "quotesBase", "cartBase", "productBase", "panda", "smallMotors",
			"customMotors","motorsModel", "googleAnalytics", "visistat", "modals", "emailNotification"
		];

		layout.elements = {
			get spinner() {
				return $("[pc-container='layout--spinner']");
			}
		};

		layout.bindings = function () {
			layout._elements.body.on("click", "[pc-container='nav--go-back']", function () {
				layout._handlers.onGoBack();
			});
			layout._elements.body.on("click", "[pc-container='nav--go-back-soft']", function () {
				layout._handlers.onSoftGoBack();
			});
			layout._elements.body.on("click", "a[pc-container='nav--go-to']", function (e) {
				if(e.currentTarget.id == "order-checkout" || e.currentTarget.id == "quote-checkout")
				{
					layout._cartCheckout.handlers.doCheckout();
				}
				else if(e.currentTarget.id == "skipAndProceed")
				{
					layout._cartCheckout.handlers.proceedWithoutAdding();
				}
				layout.handlers.onGoTo(e);
			});
			layout._elements.body.on("click", "a[pc-container='nav--contact-us']", function (e) {
				layout.handlers.openMarketo(e);
			});
			layout._elements.body.on("click", "a[pc-container='nav--logout']", function (e) {
				layout.handlers.onLogout();
				
			});

		};

		layout.renderLayout = function () {
			var html = layout.templates.main(layout.context);
			layout._elements.body.html(html);
		};

		layout.renderPageLayout = function () {
			if (layout._page.template != null) {
				var html = layout._page.template(layout.context);
				layout._elements.page.replaceWith(html);
			}
		};

		layout.loading = {
			show: function () {
				layout.elements.spinner.fadeIn();
			},
			hide: function () {
				layout.elements.spinner.fadeOut(500);
			}
		};

		layout.initPageController = function () {
			layout._controller.init();
		};

		layout.initPageServices = function () {
			layout._utils.initServicesInArray(layout._page.services);
		};

		layout.checkForServerMessages = function () {
			var errorContainer = layout._stash.error;
			if (!errorContainer) return;
			layout._modals.error.show(errorContainer.message);
			layout._stash.error = null;
		};

		layout.handlers = {
			onLogout: function () {
				layout._utils.deleteCookie("JSESSIONID");
				layout._utils.setCookie("LOGGEDOUT", "YES", 1, "/");

				layout._goToPath(layout._links.logout);
				// layout._api.common.shibbolethLogout().then(function () {
				// });
			},
			onGoTo: function (event) {
				event.preventDefault();
				var path = event.currentTarget.pathname;
				
				if(path == "/rmstorefront/site-map") {
					var quoteRefNumber = $(".referenceQuoteNumber").text();
					if(quoteRefNumber != "" && quoteRefNumber != undefined && quoteRefNumber != null) {
						event.preventDefault();
						return false;
					}
				}
				
				var paramsString = event.currentTarget.search.substr(1);

				var access = layout._pageAccessRules.checkByPagePath(path, paramsString);
				if (access === false) return;

				layout._handlers.onSwitchToPath(path, paramsString);
			},
			openMarketo: function(event){
				$("#mktoForm_5539").empty();
				MktoForms2.loadForm("//app-sj07.marketo.com", "205-IAT-784", 5539);
			      //MktoForms2.loadForm("//app-sj07.marketo.com", "205-IAT-784", 5539, function (form){MktoForms2.lightbox(form).show();});
			},
			
			onPageDataInitialized: function () {

				// second check
				var access = layout._pageAccessRules.checkByPageTitle(layout._page.title);
				if (access === false) return;

				layout.initPageController();

				layout.initPageServices();

				// trackers
				layout._googleAnalytics.send("pageView");
				layout._visistat.send("VSCapture");

			},
			onControllerInitialized: function () {
				// temp 
				// update and clean up, extend rendering methods
				layout._applyScript.all();
				layout._applyScript.base.select2();

				// show error(or any) message from initial boot
				// move to separate service when scaling
				layout.checkForServerMessages();
			}

		};

		layout.registerInitialComponents = function () {

			layout._utils.initServicesInArray(layout.commonServices);

			layout._modals = layout._getService("modals");
			layout._cart = layout._getService("cartBase");
			layout._b2bUnit = layout._getService("b2bUnit");
			layout._googleAnalytics = layout._getService("googleAnalytics");
			layout._visistat = layout._getService("visistat");

			layout._pageAccessRules = layout._getPageComponent("pageAccessRules");
		};

		layout.init = function () {

			layout.renderLayout();

			layout.registerInitialComponents();

			layout._bindings();

			layout._events.registerHandler("appInitialized", layout.name, layout.handlers.onPageDataInitialized);

			layout._events.registerHandler("pageDataInitialized", layout.name, layout.handlers.onPageDataInitialized);
			layout._events.registerHandlerAsLastOne("controllerInitialized", layout.name, layout.handlers.onControllerInitialized);
			var s = document.createElement( 'script' );
		    s.setAttribute( 'src',"//app-sj07.marketo.com/js/forms2/js/forms2.min.js");
		    document.getElementById("target").appendChild( s );

		};

		return layout;

	};

	window.appComponents = appComponents;

})(window.appComponents || {});
